import { ExclamationCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import calendarStyles from "../../Calendar.module.css"

const BookingConflictWarning = () => {
  const { t } = useTranslation()
  return (
    <Tooltip placement="bottom" title={t("calendar.booking_conflict")} trigger={["hover", "focus"]}>
      <button
        type="button"
        aria-label={t("calendar.booking_conflict")}
        className={`${calendarStyles.buttonReset} cursor-pointer`}
      >
        <ExclamationCircleFilled className={calendarStyles.warningIcon} aria-hidden />
      </button>
    </Tooltip>
  )
}

export default BookingConflictWarning
